exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".avatar-soft-primary[data-v-36b89291]{background-color:rgba(55,125,255,.1);color:#377dff;width:2.2rem;height:2.2rem;display:flex;align-items:center;justify-content:center;font-weight:600}.bg-soft-info[data-v-36b89291]{background-color:rgba(0,200,255,.1)!important}.card-table .btn-white[data-v-36b89291]{border-color:#e7eaf3}.card-table .btn-white[data-v-36b89291]:hover{background-color:#f8fafd}", ""]);

// exports
